<script setup lang="ts">
  import Modal from '@leaflink/stash/Modal.vue';
  import { storeToRefs } from 'pinia';

  import { SPLIT_NAMES } from '@/constants';
  import JoinToday from '@/pages/JoinToday/JoinToday.vue';
  import PaymentProgramSelect from '@/pages/PaymentProgramSelect/PaymentProgramSelect.vue';
  import { useUserStore } from '@/piniaStores/user/user.store';

  const { getIsSplitEnabled } = storeToRefs(useUserStore());
</script>

<template>
  <Modal data-test="paymentsInterested|modal" disable-body-padding hide-header is-open>
    <PaymentProgramSelect
      v-if="getIsSplitEnabled(SPLIT_NAMES.DIRECT_PAY_ENABLED_STATES)"
      data-test="paymentProgramSelect|modal"
    />
    <JoinToday v-else data-test="joinToday|modal" />
  </Modal>
</template>

<style scoped>
  :deep(.stash-modal__dialog) {
    @apply tw-w-full tw-min-h-screen;
  }
</style>
